import { REDUX_STORE_DEFAULTS } from "../config"

const initialState = {
  isBookingUpdated: false,
  allBookingData: {},
  // Add other variables here
}

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_STORE_DEFAULTS.UPDATE_ALL_BOOKING_DATA():
      return {
        ...state,
        allBookingData: action.payload,
      }
    case REDUX_STORE_DEFAULTS.UPDATE_BOOKING_DATA():
      return {
        ...state,
        isBookingUpdated: action.payload,
      }

    default:
      return state
  }
}

export default bookingReducer
